import { render } from "./ScrollContainer.vue?vue&type=template&id=20c51802&scoped=true&ts=true"
import script from "./ScrollContainer.vue?vue&type=script&lang=ts"
export * from "./ScrollContainer.vue?vue&type=script&lang=ts"

import "./ScrollContainer.vue?vue&type=style&index=0&id=20c51802&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c51802"]])

export default __exports__